export const SET_USER = 'SET_USER';
export const SET_STATUSES = 'SET_STATUSES';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const SET_BRANDS = 'SET_BRANDS';
export const SET_COMPANY_USERS = 'SET_COMPANY_USERS';
export const ADD_NEW_BRAND = 'ADD_NEW_BRAND';
export const UPDATE_IFC_BRAND = 'UPDATE_IFC_BRAND';
export const REMOVE_BRAND = 'REMOVE_NEW_BRAND';
export const REMOVE_USER_FROM_BRAND = 'REMOVE_USER_FROM_BRAND';
export const ADD_USER_TO_BRAND = 'ADD_USER_FROM_BRAND';
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
export const SET_PERM = "SET_PERM";
export const FEATURE_REQUEST = "FEATURE_REQUEST";
export const SET_SIDEBAR = "SET_SIDEBAR";
export const SET_ADMIN_MOBILE_SIDEBAR = "SET_ADMIN_MOBILE_SIDEBAR";
export const SET_CATALOGS_TREE = "SET_CATALOGS_TREE";
export const SET_CATALOGS = "SET_CATALOGS";
export const SET_COMPANY_PERMISSION = "SET_COMPANY_PERMISSION" ;
export const SET_ALL_PERMISSION = "SET_ALL_PERMISSION" ;
export const SET_ALL_HEALTH_REPORT = "SET_ALL_HEALTH_REPORT" ;
export const SET_ALL_PARAMETERS = "SET_ALL_PARAMETERS" ;
export const SET_COMPANY_SETTINGS = "SET_COMPANY_SETTINGS" ;
export const UPDATE_BRAND = "UPDATE_BRAND";
export const SET_PERSONAL_AREA_ACTIVE_TAB = "SET_PERSONAL_AREA_ACTIVE_TAB";
export const SET_COMPANY_ROLE = "SET_COMPANY_ROLE";
export const SET_USER_ANALYTICS = "SET_USER_ANALYTICS" ;
export const REFRESH_BRANDS = "REFRESH_BRANDS" ;
export const BRAND_FILES_TREE = "BRAND_FILES_TREE";
export const SET_ACTIVE_BRAND_CONTEXT = 'SET_ACTIVE_BRAND_CONTEXT';
export const RESET_BRAND_ACTIVE_CONTEXT = 'RESET_BRAND_ACTIVE_CONTEXT';

export const UPSERT_BRAND = "UPSERT_BRAND";
export const SET_BRAND_SETTINGS = "SET_BRAND_SETTINGS";
export const PATCH_BRAND_SETTINGS = "PATCH_BRAND_SETTINGS";
export const UPSERT_SOCIAL_ACCOUNT = "UPSERT_SOCIAL_ACCOUNT";
export const PATCH_SOCIAL_ACCOUNT = "PATCH_SOCIAL_ACCOUNT";
export const REMOVE_SOCIAL_ACCOUNT = "REMOVE_SOCIAL_ACCOUNT";
export const UPSERT_SOCIAL_TARGET = "UPSERT_SOCIAL_TARGET";
export const PATCH_SOCIAL_TARGET = "PATCH_SOCIAL_TARGET";
export const REMOVE_SOCIAL_TARGET = "REMOVE_SOCIAL_TARGET";
export const SET_DEFAULT_SOCIAL_TARGET = "SET_DEFAULT_SOCIAL_TARGET";
export const SET_BRAND_POSTS = "SET_BRAND_POSTS";
export const APPEND_BRAND_POSTS = "APPEND_BRAND_POSTS";
export const SET_BRAND_IDEAS = "SET_BRAND_IDEAS";
export const APPEND_BRAND_IDEAS = "APPEND_BRAND_IDEAS";


// export const ADD_NEW_POST = "ADD_NEW_POST";











